module.exports = __webpack_public_path__ + "media/images/btn_icon_area-261f94ec1a8349b35680be39f973d815.png";